//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        index: {
            type: Number,
            default: 0
        }
    },
    data (){
        return {
            footer: [
            {
                icon: 'icon-home',
                title: '首页',
                url: '/home'
            },
            {
                icon: 'icon-yonghutouxiang',
                title: '我的',
                url: '/mine'
            }
        ]
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/footerNav/footerNav.vue